import { ConsumerConfigDto, ConsumerReportDto, ProviderConfigDto, ProviderReportDto } from '../../services/reports-api.service';

export type ReportType = 'data-provider' | 'consumer';

export interface ReportConfig {
  id: string;
  entityId: string;
  entityName: string;
  type: ReportType;
  status: number;
  revenueShare?: number | null;
  planIncludedAudiences?: number | null;
  planIncludedDrafts?: number | null;
  pricePerAudience?: number | null;
  pricePerDraft?: number | null;
  createdAt: string;
  updatedAt: string;
}

export interface EntityFinancialReportRow {
  id: string;
  entryId: string | null;
  type: ReportType;
  direction: 'earned' | 'spent';
  entityId: string;
  entityName: string;
  reportDate: string;
  reportMonth: string;
  entryType: string;
  description: string | null;
  amount: number;
  quantity: number;
  planIncludedCount?: number;
  entryList?: string[];
  counterpartyEntityId?: string | null;
  counterpartyEntityName?: string | null;
}

export function mapProviderConfig(dto: ProviderConfigDto, entityName: string): ReportConfig {
  return {
    id: `provider::${dto.EntityID}`,
    entityId: dto.EntityID,
    entityName,
    type: 'data-provider',
    status: dto.Status,
    revenueShare: dto.RevenueShare,
    createdAt: dto.CreationTime,
    updatedAt: dto.LastUpdate
  };
}

export function mapConsumerConfig(dto: ConsumerConfigDto, entityName: string): ReportConfig {
  return {
    id: `consumer::${dto.EntityID}`,
    entityId: dto.EntityID,
    entityName,
    type: 'consumer',
    status: dto.Status,
    planIncludedAudiences: dto.PlanIncludedAudiences,
    planIncludedDrafts: dto.PlanIncludedDrafts,
    pricePerAudience: dto.PricePerAudience,
    pricePerDraft: dto.PricePerDraft,
    createdAt: dto.CreationTime,
    updatedAt: dto.LastUpdate
  };
}

export function mapProviderReport(dto: ProviderReportDto, entityName: string): EntityFinancialReportRow {
  return {
    id: `provider-report::${dto.EntityID}::${dto.ReportDate}::${dto.EntryType}`,
    entryId: dto.EntryID ?? null,
    type: 'data-provider',
    direction: 'earned',
    entityId: dto.EntityID,
    entityName,
    reportDate: typeof dto.ReportDate === 'string' ? dto.ReportDate : String(dto.ReportDate),
    reportMonth: String(dto.ReportMonth),
    entryType: dto.EntryType,
    description: dto.EntryDescription,
    amount: dto.EntryCost,
    quantity: dto.EntryAmount
  };
}

export function mapConsumerReport(dto: ConsumerReportDto, entityName: string): EntityFinancialReportRow {
  return {
    id: `consumer-report::${dto.EntityID}::${dto.ReportMonth}::${dto.EntryType}`,
    entryId: dto.EntryID ?? null,
    type: 'consumer',
    direction: 'spent',
    entityId: dto.EntityID,
    entityName,
    reportDate: dto.LastRecordDate ?? dto.ReportMonth,
    reportMonth: dto.ReportMonth,
    entryType: dto.EntryType,
    description: dto.EntryDescription,
    amount: dto.TotalCost,
    quantity: dto.TotalAmount,
    planIncludedCount: dto.PlanIncludedCount,
    entryList: dto.EntryList ?? []
  };
}
